import React, { useEffect, useState } from "react";
import Footer from "../../Footer/Footer";
import Navbar from "../../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  onUpdateProfile,
  onUpdateProfileImage,
  onUserEditProfileOther,
  onUserRemoveProfile,
  onUserUpdateProfileOther,
} from "../../../redux/homeAction";
import Banner from "../../Banner/Banner";
import { toast } from "react-toastify";
import Loader from "../../loader/Loader";

const EditProfile = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(0);
  const [value, setValue] = useState({});
  const [imageFile, setImageFile] = useState();
  const [image, setImage] = useState("");
  const [loader, setLoader] = useState(false);
  const [copied, setCopied] = useState(false);
  const [emailError, setEmailError] = useState("");

  const userDeatils = JSON.parse(localStorage.getItem("userDetails"));
  const getOnMyProfile = useSelector((state) => state.home.getOnMyProfile);
  const getOnUpdateProfile = useSelector((state) => state.home.getOnUpdateProfile);
  const getUserEditProfileOther = useSelector(
    (state) => state.home.getUserEditProfileOther
  );

  useEffect(() => {
    setValue(getOnMyProfile);
  }, [getOnMyProfile]);

  useEffect(() => {
    if (getOnUpdateProfile?.status === "failure") {
      if (getOnUpdateProfile?.errors?.email) {
        setEmailError(getOnUpdateProfile.errors.email[0]);
      }
      if (getOnUpdateProfile?.message) {
        toast.error(getOnUpdateProfile.message);
      }
    }
  }, [getOnUpdateProfile]);

  const onInputHandler = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const updateProfile = (e) => {
    e.preventDefault();
    setEmailError("");
    const data = {
      user_id: userDeatils && userDeatils.user_id,
      username: value.username,
      full_name: value.full_name,
      gender: value.gender,
      email: value.email,
      country: value.country
    };
    if (!value.username) {
      toast.error("please enter a user name");
    } else if (!value.full_name) {
      toast.error("please enter a full name");
    } else if (!value.email) {
      toast.error("please enter an email");
    } else if (!validateEmail(value.email)) {
      toast.error("please enter a valid email");
    } else {
      dispatch(onUpdateProfile(data));
    }
  };

  const onFileChange = async (e) => {
    const file = e.target.files[0];
    const base64 = await ConvertBase64(file);
    setImage(base64);
    setImageFile(base64.slice(23, base64.length));
    if (file) {
      const formData = new FormData();
      formData.append("user_id", userDeatils && userDeatils.user_id);
      formData.append("image", file);
      dispatch(onUpdateProfileImage(formData));
    }
  };

  const ConvertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (err) => {
        reject(err);
      };
    });
  };

  const userOtherProfileUpdate = (e) => {
    setLoader(true);
    e.preventDefault();
    const data = {
      user_id: userDeatils && userDeatils.user_id,
      country: value.country,
      marital_status: value.marital_status,
      profession: value.profession,
      whats_you_job: value.whats_you_job,
      education_level: value.education_level,
      school_name: value.school_name,
      university_name: value.university_name,
      spoken_language: value.spoken_language,
      countries_visited: value.countries_visited,
      favorite_sport: value.favorite_sport,
      facebook_account: value.facebook_account,
      twitter_account: value.twitter_account,
      favorite_movies: value.favorite_movies,
      favorite_song: value.favorite_song,
      favorite_book: value.favorite_book,
      favorite_singers: value.favorite_singers,
      favorite_historical: value.favorite_historical,
      favorite_soccer_team: value.favorite_soccer_team,
      favorite_nba_team: value.favorite_nba_team,
      perferred_mlb_team: value.perferred_mlb_team,
      perferred_nfl_team: value.perferred_nfl_team,
      football_favorites_goalkeeper: value.football_favorites_goalkeeper,
      football_favorites_center_back: value.football_favorites_center_back,
      football_favorites_side: value.football_favorites_side,
      football_favorites_flyer: value.football_favorites_flyer,
      football_favorites_striker: value.football_favorites_striker,
      football_favorites_player: value.football_favorites_player,
      football_favorites_midfielder: value.football_favorites_midfielder,
    };
    dispatch(onUserUpdateProfileOther(data, setLoader));
  };

  useEffect(() => {
    setLoader(true);
    const data = {
      user_id: userDeatils && userDeatils.user_id,
    };
    dispatch(onUserEditProfileOther(data, setLoader));
  }, []);

  const classSend = "position-relative";

  const deleteUserImage = () => {
    setLoader(true);
    const data = {
      user_id: userDeatils && userDeatils.user_id,
    };
    dispatch(onUserRemoveProfile(data, setLoader));
  };

  const baseRegistrationUrl = "/register";
  const referralLink = value?.username
    ? `${window.location.origin}${baseRegistrationUrl}?ref=${value.username}`
    : "";

  const handleCopyLink = () => {
    if (!referralLink) return;
    navigator.clipboard.writeText(referralLink)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        toast.error("Failed to copy link.");
      });
  };

  return (
    <>
      <Navbar classSend={classSend} />

      <section id="Tabs_section">
        <div className="container">
          <div className="tabs_container">
            <h1 className="text-center mt-3">
              Edit <span className="color_yellow">Profile</span>
            </h1>
            <div className="tabs_nav">
              <ul id="tabs">
                <li className="active_tab">
                  <div>
                    <span>Edit Profile</span>
                  </div>
                </li>
                <li>
                  <div>
                    <NavLink to="/dashboard-setting">Change Password</NavLink>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bats_nav">
              <ul id="edit_tabs">
                <li
                  onClick={() => setShow(0)}
                  className={`${show === 0 ? "active_bat" : ""}`}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <a>DETAILS</a>
                  </div>
                </li>
                {/* <li
                  onClick={() => {
                    if (getUserEditProfileOther) {
                      setValue(getUserEditProfileOther);
                    }
                    setShow(1);
                  }}
                  className={`${show === 1 ? "active_bat" : ""}`}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <a>OTHERS</a>
                  </div>
                </li> */}
              </ul>
            </div>
            <div className="bets_section">
              {show === 0 && (
                <div className="edit_section">
                  <div className="Edit_essential">
                    {loader ? (
                      <div className="text-center">
                        <Loader />
                      </div>
                    ) : (
                      <div className="edit_profile_photo">
                        <div className="profile_photo">
                          <div className="profile_img">
                            <input
                              type="file"
                              name="file"
                              id="file"
                              className="d-none"
                              onChange={onFileChange}
                            />
                            {imageFile ? (
                              <img src={image} className="profile_photo" />
                            ) : (
                              <img
                                src={`${
                                  getOnMyProfile?.image
                                    ? getOnMyProfile && getOnMyProfile.image
                                    : "./images/Profile_photo.png"
                                }`}
                                className="profile_photo"
                              />
                            )}
                            <label htmlFor="file">
                              <div className="edit_profile_photo_icon">
                                <i className="fas fa-pencil-alt"></i>
                              </div>
                            </label>
                          </div>
                        </div>

                        {getOnMyProfile && getOnMyProfile.image ? (
                          <div
                            className="delete_profile_photo"
                            onClick={deleteUserImage}
                          >
                            <i className="fa fa-trash-o"></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    <div className="preference_container">
                      <div className="form_container">
                        <form onSubmit={updateProfile}>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <input
                                type="email"
                                className="input"
                                placeholder="E - mail"
                                name="email"
                                onChange={(e) => {
                                  onInputHandler(e);
                                  setEmailError("");
                                  if (!validateEmail(e.target.value)) {
                                    setEmailError("Please enter a valid email");
                                  }
                                }}
                                value={value?.email}
                              />
                              {(emailError || (getOnUpdateProfile?.status === "failure" && getOnUpdateProfile?.errors?.email)) && (
                                <div className="text-danger mt-1">
                                  {emailError || getOnUpdateProfile?.errors?.email[0]}
                                </div>
                              )}
                            </div>

                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="User Name"
                                name="username"
                                onChange={(e) => onInputHandler(e)}
                                value={value?.username}
                                disabled
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="mail"
                                className="input"
                                placeholder="Full Name"
                                name="full_name"
                                onChange={(e) => onInputHandler(e)}
                                value={value?.full_name}
                                disabled
                              />
                            </div>
                            {/* <div className="col-md-6">
                              <div className="gender_input position-relative">
                                <input
                                  type="mail"
                                  id="gender"
                                  className="input"
                                  placeholder="Gender"
                                  disabled
                                />
                                <div className="labels">
                                  <label className="control control--radio control--checkbox">
                                    <input
                                      type="radio"
                                      name="gender"
                                      onChange={(e) => onInputHandler(e)}
                                      value="male"
                                      checked={value?.gender === "male"}
                                    />
                                    <span>Male</span>
                                    <div className="control__indicator" />
                                  </label>
                                  <label className="control control--radio control--checkbox">
                                    <input
                                      type="radio"
                                      name="gender"
                                      onChange={(e) => onInputHandler(e)}
                                      value="female"
                                      checked={value?.gender === "female"}
                                    />
                                    <span>Female</span>
                                    <div className="control__indicator" />
                                  </label>
                                </div>
                              </div>
                            </div> */}
                            <div className="col-md-6">
                              <select
                                id="country"
                                className="input"
                                name="country"
                                onChange={(e) => onInputHandler(e)}
                                value={value?.country || ""}
                                disabled={!!value?.country}
                              >
                                <option value="Afghanistan">Afghanistan</option>
                                <option value="Albania">Albania</option>
                                <option value="Algeria">Algeria</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Angola">Angola</option>
                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas">Bahamas</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Benin">Benin</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                <option value="Botswana">Botswana</option>
                                <option value="Brazil">Brazil</option>
                                <option value="Brunei">Brunei</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Burkina Faso">Burkina Faso</option>
                                <option value="Burundi">Burundi</option>
                                <option value="Cabo Verde">Cabo Verde</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Canada">Canada</option>
                                <option value="Central African Republic">Central African Republic</option>
                                <option value="Chad">Chad</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Comoros">Comoros</option>
                                <option value="Congo">Congo</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Croatia">Croatia</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">Czech Republic</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Djibouti">Djibouti</option>
                                <option value="Dominica">Dominica</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Egypt">Egypt</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                <option value="Eritrea">Eritrea</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Eswatini">Eswatini</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Fiji">Fiji</option>
                                <option value="Finland">Finland</option>
                                <option value="France">France</option>
                                <option value="Gabon">Gabon</option>
                                <option value="Gambia">Gambia</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Greece">Greece</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Guinea">Guinea</option>
                                <option value="Guinea-Bissau">Guinea-Bissau</option>
                                <option value="Guyana">Guyana</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Iran">Iran</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Jamaica">Jamaica</option>
                                <option value="Japan">Japan</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Kiribati">Kiribati</option>
                                <option value="Kuwait">Kuwait</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Laos">Laos</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Lesotho">Lesotho</option>
                                <option value="Liberia">Liberia</option>
                                <option value="Libya">Libya</option>
                                <option value="Liechtenstein">Liechtenstein</option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Maldives">Maldives</option>
                                <option value="Mali">Mali</option>
                                <option value="Malta">Malta</option>
                                <option value="Marshall Islands">Marshall Islands</option>
                                <option value="Mauritania">Mauritania</option>
                                <option value="Mauritius">Mauritius</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Micronesia">Micronesia</option>
                                <option value="Moldova">Moldova</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montenegro">Montenegro</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="Namibia">Namibia</option>
                                <option value="Nauru">Nauru</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Niger">Niger</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="North Korea">North Korea</option>
                                <option value="North Macedonia">North Macedonia</option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Palau">Palau</option>
                                <option value="Palestine">Palestine</option>
                                <option value="Panama">Panama</option>
                                <option value="Papua New Guinea">Papua New Guinea</option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Peru">Peru</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Qatar">Qatar</option>
                                <option value="Romania">Romania</option>
                                <option value="Russia">Russia</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                <option value="Saint Lucia">Saint Lucia</option>
                                <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                                <option value="Samoa">Samoa</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                <option value="Saudi Arabia">Saudi Arabia</option>
                                <option value="Senegal">Senegal</option>
                                <option value="Serbia">Serbia</option>
                                <option value="Seychelles">Seychelles</option>
                                <option value="Sierra Leone">Sierra Leone</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="Solomon Islands">Solomon Islands</option>
                                <option value="Somalia">Somalia</option>
                                <option value="South Africa">South Africa</option>
                                <option value="South Korea">South Korea</option>
                                <option value="South Sudan">South Sudan</option>
                                <option value="Spain">Spain</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Syria">Syria</option>
                                <option value="Taiwan">Taiwan</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Tanzania">Tanzania</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Timor-Leste">Timor-Leste</option>
                                <option value="Togo">Togo</option>
                                <option value="Tonga">Tonga</option>
                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Turkmenistan">Turkmenistan</option>
                                <option value="Tuvalu">Tuvalu</option>
                                <option value="Uganda">Uganda</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Arab Emirates">United Arab Emirates</option>
                                <option value="United Kingdom">United Kingdom</option>
                                <option value="United States">United States</option>
                                <option value="Uruguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Vanuatu">Vanuatu</option>
                                <option value="Vatican City">Vatican City</option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Vietnam">Vietnam</option>
                                <option value="Yemen">Yemen</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                              </select>
                            </div>
                          </div>
                          <input
                            type="submit"
                            className="btn post_btn btnFill smallbtn mt-4 mb-4"
                          />
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* --- Referral Link Section - ADDING HERE --- */}
                  {referralLink && (
                    <div className="referral_section mt-4 p-3" style={{border: '1px solid #eee', borderRadius: '5px'}}>
                      <h3 className="mb-2">Referral Link</h3>
                      <p>Share this link with friends to earn points!</p>
                      <div className="mb-2">
                         <input
                          type="text"
                          className="input w-100"
                          value={referralLink}
                          readOnly
                          style={{ backgroundColor: '#f0f0f0' }}
                        />
                       </div>
                       <div>
                        <button
                          onClick={handleCopyLink}
                          className="btn post_btn btnFill smallbtn"
                          style={{ minWidth: '100px' }}
                          disabled={copied}
                         >
                          {copied ? "Copied!" : "Copy Link"}
                        </button>
                       </div>
                    </div>
                  )}
                  {/* --- End Referral Link Section --- */}

                </div>
              )}
              {show === 1 && (
                <div className="edit_section">
                  <div className="Edit_others">
                    <div className="preference_container">
                      <div className="form_container">
                        <form>
                          <div className="row g-3">
                            <p className="boldP">Others</p>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Country"
                                name="country"
                                onChange={(e) => onInputHandler(e)}
                                value={value.country}
                              />
                            </div>
                            <div className="col-md-6">
                              <select
                                id="country"
                                className="input"
                                name="marital_status"
                                onChange={(e) => onInputHandler(e)}
                                value={value.marital_status || ''}
                              >
                                <option value="">Marital status</option>
                                <option value="single">Single</option>
                                <option value="married">Married</option>
                                <option value="unmarried">Unmarried</option>
                              </select>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Profession"
                                name="profession"
                                onChange={(e) => onInputHandler(e)}
                                value={value.profession}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What's your job"
                                name="whats_you_job"
                                onChange={(e) => onInputHandler(e)}
                                value={value.whats_you_job}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Education level"
                                name="education_level"
                                onChange={(e) => onInputHandler(e)}
                                value={value.education_level}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What's your university name"
                                name="university_name"
                                onChange={(e) => onInputHandler(e)}
                                value={value.university_name}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Name of your school"
                                name="school_name"
                                onChange={(e) => onInputHandler(e)}
                                value={value.school_name}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Spoken languages"
                                name="spoken_language"
                                onChange={(e) => onInputHandler(e)}
                                value={value.spoken_language}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Countries visited"
                                name="countries_visited"
                                onChange={(e) => onInputHandler(e)}
                                value={value.countries_visited}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Favorite sport"
                                name="favorite_sport"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_sport}
                              />
                            </div>
                            <p className="boldP">Social Networks</p>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Link to facebook account"
                                name="facebook_account"
                                onChange={(e) => onInputHandler(e)}
                                value={value.facebook_account}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Link to the twitter account"
                                name="twitter_account"
                                onChange={(e) => onInputHandler(e)}
                                value={value.twitter_account}
                              />
                            </div>
                            <p className="boldP">Favorites</p>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Top 3 Favorite Movies"
                                name="favorite_movies"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_movies}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Top 3 Favorite Songs"
                                name="favorite_song"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_song}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Top 3 Favorite books"
                                name="favorite_book"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_book}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Top 3 Bands / Favorite Singers"
                                name="favorite_singers"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_singers}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Favourite historical character	"
                                name="favorite_historical"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_historical}
                              />
                            </div>
                            <p className="boldP">Sports</p>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Favorite soccer team	"
                                name="favorite_soccer_team"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_soccer_team}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Favorite NBA team"
                                name="favorite_nba_team"
                                onChange={(e) => onInputHandler(e)}
                                value={value.favorite_nba_team}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Preferred MLB Team"
                                name="perferred_mlb_team"
                                onChange={(e) => onInputHandler(e)}
                                value={value.perferred_mlb_team}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Preferred NFL Team"
                                name="perferred_nfl_team"
                                onChange={(e) => onInputHandler(e)}
                                value={value.perferred_nfl_team}
                              />
                            </div>
                            <p className="boldP">Football Favorites</p>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What is your favorite goalkeeper?"
                                name="football_favorites_goalkeeper"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_goalkeeper}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Who is your favorite center back?	
                                
                      "
                                name="football_favorites_center_back"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_center_back}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What is your favorite side?"
                                name="football_favorites_side"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_side}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What is your favorite recovery flyer?"
                                name="football_favorites_flyer"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_flyer}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What is your favorite striker?"
                                name="football_favorites_striker"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_striker}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="Who do you consider the most overrated player?"
                                name="football_favorites_player"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_player}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="input"
                                placeholder="What is your favorite midfielder?"
                                name="football_favorites_midfielder"
                                onChange={(e) => onInputHandler(e)}
                                value={value.football_favorites_midfielder}
                              />
                            </div>
                          </div>
                          {loader ? (
                            <Loader />
                          ) : (
                            <input
                              type="submit"
                              className="btn post_btn btnFill smallbtn"
                              onClick={userOtherProfileUpdate}
                            />
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <Banner />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default EditProfile;
